module.exports = __webpack_public_path__ + "static/media/img_realtime-dashboard.ca039ce1.png";